import React from 'react';
import ReactDOM from 'react-dom';
import { Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import ReduxToastr from 'react-redux-toastr';
import 'semantic-ui-css/semantic.min.css';
// import './semantic-responsive.css';
import 'react-redux-toastr/lib/css/react-redux-toastr.min.css';
import 'react-confirm-alert/src/react-confirm-alert.css';
import './index.css';
import 'text-security/dist/text-security.css';
import App from './app/layout/App';
import store from './app/store';
import history from './app/common/util/history';
import ScrollToTop from './app/common/util/ScrollToTop';

let render = () => {
  ReactDOM.render(
    <Provider store={store}>
      <Router history={history}>
        <ScrollToTop>
          <ReduxToastr 
            position="top-right"
            transitionIn="fadeIn"
            transitionOut="fadeOut"
            preventDuplicates
          />
          <App />
        </ScrollToTop>
      </Router>
    </Provider>,
    document.getElementById('root')
  );
};

if (module.hot) {
  module.hot.accept('./app/layout/App', () => {
    setTimeout(render);
  });
}

render();
